document.addEventListener('DOMContentLoaded', function() {
    
    // Get current product title
    function getCurrentProductTitle() {
        // Try to get title from the currently displayed product
        const productTitle = document.querySelector('.without-subscription-bundle .product-title');
        if (productTitle && productTitle.textContent.trim()) {
            return productTitle.textContent.trim();
        }
        
        // Fallback: try to get from selected wash option data
        const selectedWashOption = document.querySelector('.wash-option.selected');
        if (selectedWashOption) {
            const handle = selectedWashOption.dataset.handle;
            const selectedWashProduct = window.washItems && window.washItems[handle];
            if (selectedWashProduct && selectedWashProduct.productTitle) {
                return selectedWashProduct.productTitle;
            }
        }
        
        // Final fallback: return empty string (will use default cart behavior)
        return '';
    }

    // Add to cart functionality
    function addToCart(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const originalText = button.textContent;
        
        // Set loading state
        button.disabled = true;
        button.style.opacity = '0.6';
        button.style.cursor = 'not-allowed';
        button.textContent = 'Adding...';
        
        const varID = event.currentTarget.previousElementSibling.value;
        const productTitle = getCurrentProductTitle();
        
        // Create item object with _item_title property if title exists
        const item = { id: varID, quantity: 1 };
        if (productTitle) {
            item.properties = {
                '_item_title': productTitle
            };
        }
        
        const items = [item];
        
        $jq2.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { items: items },
            dataType: 'json',
            success: function(data) {
                // Show success state
                button.textContent = 'Added!';
                button.style.opacity = '1';
                
                // Open cart drawer if available
                if (typeof window.openCartDrawer === 'function') {
                    window.openCartDrawer();
                }
                
                // Reset button state after 2 seconds
                setTimeout(() => {
                    button.disabled = false;
                    button.style.opacity = '1';
                    button.style.cursor = 'pointer';
                    button.textContent = originalText;
                }, 2000);
            },
            error: function(error) {
                console.error('Error adding to cart:', error);
                
                // Show error state
                button.textContent = 'Error - Try Again';
                button.style.opacity = '1';
                
                // Reset button state after 3 seconds
                setTimeout(() => {
                    button.disabled = false;
                    button.style.opacity = '1';
                    button.style.cursor = 'pointer';
                    button.textContent = originalText;
                }, 3000);
            }
        });
    }

    // Buy now functionality with proper button state management
    function buyNow(event) {
        event.preventDefault();
        const button = event.currentTarget;
        const originalText = button.textContent;
        
        // Set loading state
        button.disabled = true;
        button.style.opacity = '0.6';
        button.style.cursor = 'not-allowed';
        button.textContent = 'Processing...';
        
        const varID = button.previousElementSibling.value;
        const productTitle = getCurrentProductTitle();
        
        // Create item object with _item_title property if title exists
        const item = { id: varID, quantity: 1 };
        if (productTitle) {
            item.properties = {
                '_item_title': productTitle
            };
        }
        
        const items = [item];
        
        $jq2.ajax({
            type: 'POST',
            url: '/cart/add.js',
            data: { items: items },
            dataType: 'json',
            success: function(data) {
                // Show success state briefly before redirect
                button.textContent = 'Redirecting...';
                setTimeout(() => {
                    window.location.href = '/checkout';
                }, 500);
            },
            error: function(error) {
                console.error('Error adding to cart:', error);
                
                // Show error state
                button.textContent = 'Error - Try Again';
                button.style.opacity = '1';
                
                // Reset button state after 3 seconds
                setTimeout(() => {
                    button.disabled = false;
                    button.style.opacity = '1';
                    button.style.cursor = 'pointer';
                    button.textContent = originalText;
                }, 3000);
            }
        });
    }

    // Buy now button handlers
    document.querySelectorAll('.without-subscription-bundle .buy_now').forEach(btn => {
        btn.addEventListener('click', buyNow);
    });

    // Sprayer option click handler (exclude wash-options)
    document.querySelectorAll('.sprayer-option:not(.wash-option)').forEach(option => {
        option.addEventListener('click', function() {
            const blockHandle = this.getAttribute('block-handle');
            console.log('Sprayer option clicked with block-handle:', blockHandle);
            
            // Hide all wash options and show the relevant one
            document.querySelectorAll('.wash-options').forEach(washOption => {
                washOption.classList.add('hidden');
            });
            
            const targetWashOptions = document.querySelector(`[data-wash-block="${blockHandle}"]`);
            console.log('Target wash options found:', targetWashOptions);
            
            if (targetWashOptions) {
                targetWashOptions.classList.remove('hidden');
                
                // Find and select the default wash option or first available option
                const defaultWashOption = targetWashOptions.querySelector('.wash-option.selected') || 
                                        targetWashOptions.querySelector('.wash-option:not([disabled])');
                
                console.log('Default wash option found:', defaultWashOption);
                
                if (defaultWashOption) {
                    // Trigger selection of default wash option to load its data
                    selectWashOption(defaultWashOption);
                }
            }
            
            // Update selected state
            document.querySelectorAll('.sprayer-option').forEach(el => {
                el.classList.remove('selected');
            });
            this.classList.add('selected');
        });
    });

    // Function to select and update wash option data
    function selectWashOption(washOptionElement) {
        if (!washOptionElement) return;
        
        const productAvailable = washOptionElement.dataset.productAvailable;
        const buyNowBtn = document.querySelector(".without-subscription-bundle .buy_now");
        const addToCartBtn = document.querySelector(".without-subscription-bundle .add_to_cart");
       
        // Update button states based on availability
        if (productAvailable === "false" || productAvailable === false) { 
            buyNowBtn.classList.add("disabled");
            addToCartBtn.classList.add("disabled");
            buyNowBtn.innerText = "SOLD OUT";
            addToCartBtn.innerText = "SOLD OUT";
        } else { 
            buyNowBtn.classList.remove("disabled");
            addToCartBtn.classList.remove("disabled");
            buyNowBtn.innerText = "BUY NOW";
            addToCartBtn.innerText = "ADD TO CART";
        }
        
        // Get wash product data from window.washItems
        const handle = washOptionElement.dataset.handle;
        const selectedWashProduct = window.washItems && window.washItems[handle];
        
        console.log('Selecting wash option with handle:', handle);
        console.log('Available window.washItems:', window.washItems);
        console.log('Selected wash product:', selectedWashProduct);
        
        if (selectedWashProduct) {
            // Update variant ID for the selected wash product
            updateVariantId(selectedWashProduct.variantId);
            
            // Always update product info (title, price, description, etc.)
            updateProductInfo(selectedWashProduct);
            
            // Update images if they exist
            if (selectedWashProduct.imageArray && selectedWashProduct.imageArray.length > 0) {
                // Destroy existing sliders before updating
                const $main = $jq2('.without-subscription-bundle .gallery-main');
                const $thumbs = $jq2('.without-subscription-bundle .gallery-thumbnails');
                
                if ($main.hasClass('slick-initialized')) {
                    $main.slick('unslick');
                }
                if ($thumbs.hasClass('slick-initialized')) {
                    $thumbs.slick('unslick');
                }
                
                updateImages(selectedWashProduct);
            }
        } else {
            // Fallback: use the variant ID from the data attribute
            const variantId = washOptionElement.dataset.variantId;
            if (variantId) {
                updateVariantId(variantId);
            }
        }
        
        // Update selected state for wash options within the visible container
        const visibleWashContainer = document.querySelector('.wash-options:not(.hidden)');
        if (visibleWashContainer) {
            visibleWashContainer.querySelectorAll('.wash-option').forEach(el => {
                el.classList.remove('selected', 'active');
            });
        }
        washOptionElement.classList.add('selected', 'active');
    }

    // Wash option click handler (treating wash-options as selectable products)
    document.querySelectorAll('.wash-option').forEach(option => {
        option.addEventListener('click', function(event) {
            selectWashOption(this);
        });
    });
    
    // Update product information
    function updateProductInfo(selectedKit) {
        // Update product title
        const productTitle = document.querySelector('.without-subscription-bundle .product-title');
        if (productTitle) {
            productTitle.textContent = selectedKit.productTitle;
            console.log('Product title updated to:', selectedKit.productTitle);
        }

        // Update product descriptions
        const productDesc = document.querySelector('.without-subscription-bundle .product-description');
        const productMobileDesc = document.querySelector('.without-subscription-bundle .product-description.mobile-desc');
        
        console.log('Product description element found:', productDesc);
        console.log('Product mobile description element found:', productMobileDesc);
        
        if (productDesc && selectedKit.prodDesc) {
            productDesc.innerHTML = selectedKit.prodDesc;
            console.log('Product description updated');
        }
        if (productMobileDesc && selectedKit.mobileDesc) {
            productMobileDesc.innerHTML = selectedKit.mobileDesc;
            console.log('Mobile description updated');
        }

        // Update pricing
        console.log('Calling updatePricing with:', selectedKit);
        updatePricing(selectedKit);
        
        // Update product features
        updateProductFeatures(selectedKit);
        
        // Update kit includes
        updateKitIncludes(selectedKit);
        
        // Update benefits section
        updateBenefits(selectedKit);
    }

    function updatePricing(selectedKit) {
        const regularPrice = document.querySelector('.without-subscription-bundle .epremium-kit__regular-price');
        const salePrice = document.querySelector('.without-subscription-bundle .epremium-kit__sale-price');
        const discount = document.querySelector('.without-subscription-bundle .epremium-kit__discount');

        if (regularPrice && selectedKit.comparePrice) {
            regularPrice.textContent = selectedKit.comparePrice;
            console.log('Regular price updated to:', selectedKit.comparePrice);
        }
        if (salePrice && selectedKit.price) {
            salePrice.textContent = selectedKit.price;
            console.log('Sale price updated to:', selectedKit.price);
        }
        if (discount && selectedKit.comparePrice && selectedKit.price) {
            const comparePrice = parseFloat(selectedKit.comparePrice.replace(/[^0-9.-]+/g, ''));
            const salePriceNum = parseFloat(selectedKit.price.replace(/[^0-9.-]+/g, ''));
            const saving = ((comparePrice - salePriceNum) / comparePrice * 100).toFixed(0);
            discount.textContent = `Save ${saving}%`;
            console.log('Discount updated to:', `Save ${saving}%`);
        }
    }

    function updateProductFeatures(selectedKit) {
        const featuresSection = document.querySelector('.without-subscription-bundle .product-features');
        if (featuresSection && selectedKit.productFeature) {
            const featuresHtml = selectedKit.productFeature.features.map(feature => `
                <div class="feature">
                    <img src="${feature.icon}" class="epremium-kit__product-image" loading="lazy" alt="${feature.title}">
                    <span class="feature_text">${feature.title}</span>
                </div>
            `).join('');
            featuresSection.innerHTML = featuresHtml;
        }
    }

    function updateKitIncludes(selectedKit) {
        const includesSection = document.querySelector('.without-subscription-bundle .epremium-kit__includes');
        if (includesSection && selectedKit.kitIncludes) {
            const includesHtml = `
                <h3>${selectedKit.kitIncludes.heading}:</h3>
                <ul class="epremium-kit__items">
                    ${selectedKit.kitIncludes.details.map(include => `
                        <li class="epremium-kit__item">
                            <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10 20C9.71048 10.5262 9.4738 10.291 0 10C9.4738 9.71048 9.70903 9.4738 10 0C10.2895 9.4738 10.5262 9.70903 20 10C10.5262 10.291 10.291 10.5233 10 20Z" fill="black"/>
                            </svg>
                            <p class="epremium-kit__item-title">${include.title}</p>
                        </li>
                    `).join('')}
                </ul>
            `;
            includesSection.innerHTML = includesHtml;
        }
    }

    function updateBenefits(selectedKit) {
        const benefitsSection = document.querySelector('.without-subscription-bundle .product-benefits');
        if (benefitsSection && selectedKit.benefits) {
            const benefitsHtml = `
                <h2>${selectedKit.benefits.title}</h2>
                <div class="benefits-list">
                    ${selectedKit.benefits.benefitsList.map(benefit => `
                        <div class="benefit">
                            <img src="${benefit.icon}" class="rubbit_detail_img" loading="lazy" alt="${benefit.title}">
                            <div class="benifit_heading_subheading_wrapper">
                                <h3>${benefit.title}</h3>
                                <p>${benefit.description}</p>
                            </div>
                        </div>
                    `).join('')}
                </div>
            `;
            benefitsSection.innerHTML = benefitsHtml;
        }
    }

    function updateVariantId(variantId) {
        // Update variant ID in form
        const variantInput = document.querySelector('.without-subscription-bundle input[name="id"]');
        if (variantInput) {
            variantInput.value = variantId;
        }

        // Update all kit buttons
        document.querySelectorAll(".without-subscription-bundle [data-add-kit]").forEach(btn => {
            if (btn.previousElementSibling) {
                btn.previousElementSibling.value = variantId;
            }
        });
    }

    function updateImages(selectedKit) {
        const galleryImages = selectedKit.imageArray;
        const galleryWrapper = document.querySelector(".without-subscription-bundle .gallery-main");
        const thumbnailWrapper = document.querySelector(".without-subscription-bundle .gallery-thumbnails");
        
        if (!galleryWrapper || !thumbnailWrapper) return;
    
        const galleryHtml = galleryImages.map((image, index) => `
            <div class="gallery-item${index === 0 ? ' active' : ''}">
                <img src="${image}" alt="Product image ${index + 1}">
            </div>
        `).join('');
    
        const thumbnailHtml = galleryImages.map((image, index) => `
            <div class="thumbnail${index === 0 ? ' active' : ''}">
                <img src="${image}" alt="Thumbnail ${index + 1}">
            </div>
        `).join('');
    
        // Update the HTML content
        galleryWrapper.innerHTML = galleryHtml;
        thumbnailWrapper.innerHTML = thumbnailHtml;
        
        // Initialize sliders
        initializeSliders();
    }

    function initializeSliders() {
        if (typeof $jq2.fn.slick === 'undefined') {
            console.error("Slick not loaded");
            return;
        }

        const $main = $jq2('.without-subscription-bundle .gallery-main');
        const $thumbs = $jq2('.without-subscription-bundle .gallery-thumbnails');

        const slickConfig = {
            main: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true,
                infinite: false,
                variableWidth: false,
                centerMode: false,
                prevArrow: '<button class="slick_prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="tabler:arrow-up"><path id="Vector" d="M5 12H19M5 12L11 6M5 12L11 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>',
                nextArrow: '<button class="slick_next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="tabler:arrow-up"><path id="Vector" d="M19 12H5M19 12L13 18M19 12L13 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>',
                responsive: [{
                    breakpoint: 767,
                    settings: {
                        slidesPerView: 1,
                        slidesToScroll: 1,
                        arrows: false,
                        infinite: false,
                        dots: true,
                        autoplay: false
                    }
                }]
            },
            thumbs: {
                slidesToShow: 8,
                slidesToScroll: 1,
                asNavFor: '.gallery-main',
                infinite: false,
                dots: false,
                prevArrow: '<button class="slick_prev"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="tabler:arrow-up"><path id="Vector" d="M5 12H19M5 12L11 6M5 12L11 18" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>',
                nextArrow: '<button class="slick_next"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><g id="tabler:arrow-up"><path id="Vector" d="M19 12H5M19 12L13 18M19 12L13 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></g></svg></button>',
                focusOnSelect: true,
                breakpoints: {
                    769: {
                        slidesPerView: 6,
                        slidesToScroll: 1
                    }
                }
            }
        };

        $main.slick(slickConfig.main);
        $thumbs.slick(slickConfig.thumbs);
        
        // Fix transform precision issues
        $main.on('afterChange', function(event, slick, currentSlide) {
            const $track = $jq2(this).find('.slick-track');
            const transform = $track.css('transform');
            if (transform && transform.includes('translate3d')) {
                // Round the transform values to prevent 1px peek
                const matches = transform.match(/translate3d\(([^,]+),\s*([^,]+),\s*([^)]+)\)/);
                if (matches) {
                    const x = Math.round(parseFloat(matches[1]));
                    const y = Math.round(parseFloat(matches[2]));
                    const z = matches[3];
                    $track.css('transform', `translate3d(${x}px, ${y}px, ${z})`);
                }
            }
        });
    }
});